import {
  AUTH_REQUESTING,
  AUTH_SUCCESS,
  AUTH_ERROR,
  AUTH_LIST_REQUESTING,
  AUTH_LIST_ERROR,
  AUTH_LIST_SUCCESS,
  GENERATE_AUTH_ERROR,
  GENERATE_AUTH_SUCCESS,
  GENERATE_AUTH_REQUESTING,
  CHANGE_PASS_REQUESTING,
  CHANGE_PASS_SUCCESS,
  CHANGE_PASS_ERROR,
  CHANGE_USER_REQUESTING,
  CHANGE_USER_SUCCESS,
  CHANGE_USER_ERROR,
  CHANGE_BANK_ERROR,
  CHANGE_BANK_SUCCESS,
  CHANGE_BANK_REQUESTING,
} from './constants';

const initialState = {
  requesting: false,
  successful: false,
  errors: [],

  actList: [],
  generateAuth: {},

  changePassRequesting: false,
  changePassSuccessful: false,
  changePassMessages: [],
  changePassErrors: [],

  changeUserRequesting: false,
  changeUserSuccessful: false,
  changeUserMessages: [],
  changeUserErrors: [],

  changeBankRequesting: false,
  changeBankSuccessful: false,
  changeBankMessages: [],
  changeBankErrors: [],
};

const reducer = function authReducer(state = initialState, action) {
  switch (action.type) {
    case 'INVALID_SESSION':
    case 'CLIENT_UNSET':
    case 'LOG_OUT':
      return initialState;
    case 'RESET_AUTH':
      return {
        ...state,
        errors: [],
      };

    case 'CLEAR_AUTH':
      return {
        ...state,
        requesting: false,
        successful: false,
        errors: [],
      };

    case AUTH_REQUESTING:
      return {
        ...state,
        requesting: true,
        successful: false,
        errors: [],
      };

    case AUTH_SUCCESS:
      return {
        ...state,
        errors: [],
        requesting: false,
        successful: true,
      };

    case AUTH_ERROR:
      return {
        ...state,
        errors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
        requesting: false,
        successful: false,
      };

    case AUTH_LIST_REQUESTING:
    case AUTH_LIST_ERROR:
      return {
        ...state,
        actList: [],
      };

    case AUTH_LIST_SUCCESS:
      return {
        ...state,
        actList: action.resData,
      };

    case GENERATE_AUTH_REQUESTING:
    case GENERATE_AUTH_ERROR:
      return {
        ...state,
        generateAuth: {},
      };

    case GENERATE_AUTH_SUCCESS:
      return {
        ...state,
        generateAuth: action.resData,
      };

    case CHANGE_PASS_REQUESTING:
      return {
        ...state,
        changePassRequesting: true,
        changePassSuccessful: false,
        changePassMessages: [
          { body: 'Change password in...', time: new Date() },
        ],
        changePassErrors: [],
      };

    case CHANGE_PASS_SUCCESS:
      return {
        ...state,
        changePassRequesting: false,
        changePassSuccessful: true,
        changePassMessages: [],
        changePassErrors: [],
      };

    case CHANGE_PASS_ERROR:
      return {
        ...state,
        changePassRequesting: false,
        changePassSuccessful: false,
        changePassMessages: [],
        changePassErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case CHANGE_USER_REQUESTING:
      return {
        ...state,
        changeUserRequesting: true,
        changeUserSuccessful: false,
        changeUserMessages: [
          { body: 'Change user login in...', time: new Date() },
        ],
        changeUserErrors: [],
      };

    case CHANGE_USER_SUCCESS:
      return {
        ...state,
        changeUserRequesting: false,
        changeUserSuccessful: true,
        changeUserMessages: [],
        changeUserErrors: [],
      };

    case CHANGE_USER_ERROR:
      return {
        ...state,
        changeUserRequesting: false,
        changeUserSuccessful: false,
        changeUserMessages: [],
        changeUserErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case CHANGE_BANK_REQUESTING:
      return {
        ...state,
        changeBankRequesting: true,
        changeBankSuccessful: false,
        changeBankMessages: [
          { body: 'Change user login in...', time: new Date() },
        ],
        changeBankErrors: [],
      };

    case CHANGE_BANK_SUCCESS:
      return {
        ...state,
        changeBankRequesting: false,
        changeBankSuccessful: true,
        changeBankMessages: [],
        changeBankErrors: [],
      };

    case CHANGE_BANK_ERROR:
      return {
        ...state,
        changeBankRequesting: false,
        changeBankSuccessful: false,
        changeBankMessages: [],
        changeBankErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    default:
      return state;
  }
};

export default reducer;
